import React, { FC, SVGProps } from 'react'

export const VerificationBlueSvg: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#5AADF7"
      d="M10.701 2.004a1.925 1.925 0 0 1 2.598 0l.93.864c.415.385.99.564 1.561.487l1.283-.174c.998-.136 1.927.512 2.101 1.465l.224 1.224c.1.544.456 1.014.965 1.273l1.144.583c.89.453 1.245 1.502.803 2.37l-.57 1.117a1.727 1.727 0 0 0 0 1.574l.57 1.117c.442.868.087 1.917-.803 2.37l-1.144.583c-.51.259-.865.729-.965 1.273l-.224 1.224c-.174.953-1.103 1.6-2.1 1.465l-1.284-.174a1.918 1.918 0 0 0-1.56.487l-.931.864a1.925 1.925 0 0 1-2.598 0l-.93-.864a1.918 1.918 0 0 0-1.561-.487l-1.283.174c-.998.136-1.927-.512-2.102-1.465l-.223-1.224a1.8 1.8 0 0 0-.965-1.273l-1.144-.583c-.89-.453-1.245-1.502-.803-2.37l.57-1.117a1.727 1.727 0 0 0 0-1.574l-.57-1.117c-.442-.868-.087-1.917.803-2.37l1.144-.583a1.8 1.8 0 0 0 .965-1.273l.223-1.224C5 3.693 5.93 3.046 6.927 3.18l1.283.174a1.918 1.918 0 0 0 1.56-.487l.931-.864Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16.57 8.878c.55.528.575 1.409.06 1.969l-3.617 3.923a2.24 2.24 0 0 1-3.31 0l-2.332-2.53a1.413 1.413 0 0 1 .058-1.97 1.344 1.344 0 0 1 1.928.06l2.001 2.172 3.285-3.564a1.344 1.344 0 0 1 1.928-.06Z"
      clipRule="evenodd"
    />
  </svg>
)
